import React, { useRef } from "react";
import { message } from "antd";
import { IYhFormRef, FormItemTypeEnum, IYhForm } from "@/components/YhFormBox/Types";
import { getFormValidatorErrText } from "@/utils/utils";
import { YHDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";
import { useWebSiteModel } from "../webSiteModel";
import { IWebSiteDetails, webSiteService } from "../webSiteService";


export function DetailDrawer() {
	const { detailDrawer: { visible, mode, record }, serDetailDrawer, loadData } = useWebSiteModel();
	const formRef = useRef<IYhFormRef>();

	const onCancel = () => {
		serDetailDrawer({ visible: false, mode: "add" });
	}

	//表单提交
	const onSubmit = async () => {
		formRef.current?.validateFields().then((val: IWebSiteDetails) => {
			let data = {
				...val,
				isPwd: val.isPwd ? 1 : 0
			}
			if (mode === "add") {
				webSiteService.insert(data).then(res => {
					res && onCancel();
					message.success("新增成功");
					loadData()
				})
			} else {
				webSiteService.update({ ...data, id: record?.id }).then(res => {
					res && onCancel();
					message.success("编辑成功");
					loadData()
				})
			}
		}).catch(err => {
			message.warning(getFormValidatorErrText(err));
		})
	}



	const formConfig: IYhForm = {
		formRef,
		labelCol: { span: 6 },
		formValues: mode === "edit" ? { ...record ?? {}, isPwd: record?.isPwd === 0 ? false : true } : { isPwd: true },
		items: [
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "站点域名",
				fieldName: "code",
				span: 24,
				rules: [{ required: true, message: "请输入站点域名" }]
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "站点名称",
				fieldName: "name",
				span: 24,
				rules: [{ required: true, message: "请输站点名称" }]
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "用户名称",
				fieldName: "userName",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "用户密码",
				fieldName: "userPwd",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "备注",
				fieldName: "note",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Checkbox,
				fieldLabel: "是否免密登录",
				fieldName: "isPwd",
				span: 24,
			},
		]
	};
	return (
		<YHDrawer
			{...{
				title: `站点${mode === "edit" ? "编辑" : "新增"}`,
				visible,
				onCancel,
				okText: "保存",
				onOk: onSubmit
			}}
		>
			<YhForm {...formConfig} />
		</YHDrawer>
	)
}
